import React from 'react';
import FundOpportunity from '../../models/FundOpportunity';
import StyledSection from '../styles/StyledSection';
import { StyledCallout, StyledTypography } from '../styles/styles';
import { getFundStatusMessage } from './eoiFundStatusUtils';
import { EOITitle } from './EOISettingsContext';

export const EOISectionRestricted: React.FC<{
  fundOpportunity: FundOpportunity;
  printMode?: boolean;
}> = ({ fundOpportunity, printMode = false }) => (
  <StyledSection
    tone="tone2"
    additionalClassName="eoi-section-restricted"
    mt="1.875rem"
    withBorder={printMode}
  >
    <EOITitle>Expression of Interest</EOITitle>
    <StyledCallout variant="info" sx={{ mb: 2 }}>
      <StyledTypography>{getFundStatusMessage(fundOpportunity.status)}</StyledTypography>
    </StyledCallout>
  </StyledSection>
);
